import React, { useContext } from "react";
import axios from "axios";
import { ContentContext } from "../context/ContentContext";
import { UserContext } from "../context/UserContext";
import {
  Box,
  Heading,
  Center,
  ButtonGroup,
  Button,
  Image,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableCaption,
  useToast,
} from "@chakra-ui/react";
import { useHistory } from "react-router-dom";

const MovieList = () => {
  const { movies, fetch, setFetch } = useContext(ContentContext);
  const { user } = useContext(UserContext);
  const toast = useToast();
  const history = useHistory();

  const handleDelete = (event) => {
    event.preventDefault();
    let id = event.target.value;
    console.log(id);
    axios
      .delete(`https://backendexample.sanbersy.com/api/data-movie/${id}`, {
        headers: { Authorization: "Bearer " + user.token },
      })
      .then(() => {
        toast({
          title: "Delete success",
          position: "top",
          status: "success",
          duration: 1500,
        });
        setFetch(!fetch);
      });
  };

  const handleEdit = (event) => {
    let id = event.target.value;
    history.push(`/movie/edit/${id}`);
  };

  return (
    <Box p={4}>
      <Center>
        <Heading as="h1" size="xl">
          Movie List
        </Heading>
      </Center>
      <Button
        colorScheme="teal"
        variant="solid"
        onClick={() => history.push("/movie/create")}
      >
        Add Movie
      </Button>
      <Table variant="simple" m={4}>
        <TableCaption>Movie List</TableCaption>
        <Thead>
          <Tr>
            <Th>#</Th>
            <Th>Title</Th>
            <Th>Description</Th>
            <Th>Year</Th>
            <Th>Duration</Th>
            <Th>Rating</Th>
            <Th>Genre</Th>
            <Th>Review</Th>
            <Th>Image</Th>
            <Th>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {movies ? (
            movies.map((data, index) => {
              return (
                <Tr key={index}>
                  <Td>{data.index}</Td>
                  <Td>{data.title}</Td>
                  <Td>{data.description}</Td>
                  <Td>{data.year}</Td>
                  <Td>{data.duration} minutes</Td>
                  <Td>{data.rating} out of 10</Td>
                  <Td>{data.genre}</Td>
                  <Td>{data.review}</Td>
                  <Td>
                    <Image
                      objectFit="cover"
                      loading="lazy"
                      src={data.image}
                      alt={data.title}
                    />
                  </Td>
                  <Td>
                    <ButtonGroup variant="outline" spacing="4">
                      <Button
                        colorScheme="teal"
                        onClick={handleEdit}
                        value={data.id}
                      >
                        Edit
                      </Button>
                      <Button
                        colorScheme="red"
                        onClick={handleDelete}
                        value={data.id}
                      >
                        Delete
                      </Button>
                    </ButtonGroup>
                  </Td>
                </Tr>
              );
            })
          ) : (
            <Tr>
              <Td>Data not available</Td>
            </Tr>
          )}
        </Tbody>
      </Table>
    </Box>
  );
};

export default MovieList;
